import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconCameraOff: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconCameraOff"><Path d="M9.74829 11.25L14.25 15.7517M14.2517 11.25L9.75 15.7517M7.5 6.5H2.5V20.5H21.5V6.5H16.5L14.5 3.5H9.5L7.5 6.5Z" stroke="currentColor" strokeLinecap="square"/></CentralIconBase>;
});

export default IconCameraOff;
